module.exports = __webpack_public_path__ + "img/redelia-bates.1cf62c38.png";